// extracted by mini-css-extract-plugin
export default {"wrapper":"mr-z","response":"nr-z","error":"or-z","disabled":"pr-z","buttons":"qr-z","feedbackQuestionSection":"rr-z","yesNoWrapper":"sr-z"};